import { ArrowLeftRight, Mail, ScrollText, Sigma, Users } from "lucide-react";
import MenuIconTooltip from "./MenuIconTooltip";
import QuestLetterIcon from "./IconComponent/QuestLetterIcon";

const CPANEL_NAV_TOOLTIPS = {
  requests: "Demandes d'accès ✶ Accepter, refuser ou retirer les demandes.",
  accounts: "Comptes ✶ Consulter et supprimer les comptes et leurs données.",
  stats: "Sommes ✶ Connexions, captures, parties, quêtes, titres et marques des joueurs.",
  quests: "Quêtes ✶ Instructeurs particuliers et envoi du mail de quête.",
  inventory: "Inventaires ✶ Modifier les pierres, potions et parchemins d'un joueur.",
  official: "Messages du Royaume ✶ Annonces officielles et nouveautés du développement.",
};

export default function MenuCpanelNav({
  screen = "requests",
  onScreenChange = () => {},
  visible = true,
}) {
  if (!visible) return null;

  return (
    <div className="menuFilterContainer menuCpanelNavContainer">
      <MenuIconTooltip
        tooltip={CPANEL_NAV_TOOLTIPS.requests}
        placement="left"
        portal
        className={screen === "requests" ? "filterIcon active" : "filterIcon"}
      >
        <Mail
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("requests")}
          aria-label="Demandes d'accès"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={CPANEL_NAV_TOOLTIPS.accounts}
        placement="left"
        portal
        className={screen === "accounts" ? "filterIcon active" : "filterIcon"}
      >
        <Users
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("accounts")}
          aria-label="Comptes"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={CPANEL_NAV_TOOLTIPS.stats}
        placement="left"
        portal
        className={screen === "stats" ? "filterIcon active" : "filterIcon"}
      >
        <Sigma
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("stats")}
          aria-label="Sommes"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={CPANEL_NAV_TOOLTIPS.quests}
        placement="left"
        portal
        className={screen === "quests" ? "filterIcon active" : "filterIcon"}
      >
        <QuestLetterIcon
          size={50}
          color="#39210d"
          onClick={() => onScreenChange("quests")}
          aria-label="Quêtes"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={CPANEL_NAV_TOOLTIPS.official}
        placement="left"
        portal
        className={screen === "official" ? "filterIcon active" : "filterIcon"}
      >
        <ScrollText
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("official")}
          aria-label="Messages officiels"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={CPANEL_NAV_TOOLTIPS.inventory}
        placement="left"
        portal
        className={screen === "inventory" ? "filterIcon active" : "filterIcon"}
      >
        <ArrowLeftRight
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("inventory")}
          aria-label="Inventaires"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>
    </div>
  );
}
